import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'

import { SITE_TYPES } from '../../../utils/constants'

import DateFormat from '../../utils/dateFormat'
import Skeleton from 'react-loading-skeleton'
import { Join } from '../../utils/Join'

const Show = ({ match }) => {
  const dispatch = useDispatch()
  const facility = useSelector(store => store.facilities.facility)
  const fetching = useSelector(store => store.facilities.fetching)

  const MetaWrapper = ({ children }) => <div className="">{children}</div>
  const MetaHeader = ({ children }) => <div className="tracking-wide text-sm text-gray-400">{children}</div>
  const MetaDetail = ({ children, width }) => (
    <div className="text-xl">{!fetching ? children : <Skeleton width={width} />}</div>
  )
  const StatsValue = ({ children, width }) => (
    <div className="text-xl md:text-3xl lg:text-4xl">{!fetching ? children : <Skeleton width={width} />}</div>
  )

  return (
    <div className={clsx('grid grid-flow-col gap-y-2 gap-x-4 grid-rows-4')}>
      <MetaWrapper>
        <MetaHeader>Last checked at</MetaHeader>
        <MetaDetail width="20ch">
          <DateFormat format="MM/DD/YYYY hh:mm" date={facility.lastScrapeAttempt} />
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Last change in availability</MetaHeader>
        <MetaDetail width="20ch">
          <DateFormat format="MM/DD/YYYY hh:mm" date={facility.lastImport} />
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Site Count</MetaHeader>
        <MetaDetail width="2ch">{facility.sitesCount}</MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Site Breakdown</MetaHeader>
        <MetaDetail width="8ch">
          <Join
            items={Object.keys(facility?.sitesDetails?.types || []).map(type => (
              <React.Fragment key={type}>
                {SITE_TYPES[type] || type}: {facility.sitesDetails.types[type]}
              </React.Fragment>
            ))}
          />
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Site Hookups</MetaHeader>
        <MetaDetail width="8ch">
          <Join
            items={[
              facility.sitesDetails.electricCount && <>Electric: {facility.sitesDetails.electricCount}</>,
              facility.sitesDetails.waterCount && <>Water: {facility.sitesDetails.waterCount}</>,
              facility.sitesDetails.sewerCount && <>Sewer: {facility.sitesDetails.sewerCount}</>
            ]}
          />

          {facility.sitesDetails.electricCount === 0 &&
            facility.sitesDetails.waterCount === 0 &&
            facility.sitesDetails.sewerCount === 0 && <>(None)</>}
        </MetaDetail>
      </MetaWrapper>
    </div>
  )
}

export default Show
